import { useQuery } from '@tanstack/react-query';
import { appelApi } from './api';
import type { ReponseSites } from './types';

/** Antennes visibles par l'utilisateur, pour le sélecteur de périmètre. */
export function useSites() {
  return useQuery({
    queryKey: ['sites'],
    queryFn: () => appelApi<ReponseSites>('/sites'),
    staleTime: 5 * 60 * 1000,
  });
}
